import React, { Component } from 'react'
import Button from '@mui/material/Button'
import {TextField} from '@mui/material'
import NavigateNext from '@mui/icons-material/NavigateNext'



const styles = theme => ({
    root: {
        textAlign:'center',
        padding: '15px'
    },
    textfield: {
        maxWidth:'100px',
        [theme.breakpoints.down('xs')]: {
            margin:'8px'
        }
    },
    button: {
        height:'56px',
        [theme.breakpoints.down('xs')]: {
            width:'100px',
            marginTop:'8px'
        }
    }
})

class InputAnswer extends Component{
    constructor(props){
        super(props)
        this.state = {
            invalidAnswer: true, //on ComponenetDidMount, put logic in to update htis based on response
            answer: "",
            valMin: "",
            valMax: "",
            valPrecision: "",
            errorMessage: "",
            inputError: false,
            saving: false
        }
    }

    
    componentDidMount() {
        this.setState({
            answer: this.props.question.Responses[0].Response,
            invalidAnswer: true,
            valMin: this.props.question.ValueLimitationMin,
            valMax: this.props.question.ValueLimitationMax,
            valPrecision: this.props.question.ValueLimitationPrecision
        })
    }

    componentDidUpdate(prevProps){

        if(prevProps.question.QuestionId !== this.props.question.QuestionId){
            this.setState({
                answer: this.props.question.Responses[0].Response,
                invalidAnswer: this.props.question.Responses[0].Response.length ? false : true,
                saving: false

            })
            //console.log(this.state)
        }
    }

    handleEnter = (event) => {
        if(event.key == "Enter" && !this.state.invalidAnswer){
            this.props.updateResponseValue(this.state.answer)
        }
    }

    onChange = (ev) =>{
        let value = ev.target.value
        let message = this.state.errorMessage
        let validation = this.props.validation
        //validation goes here
        //...
        //...

        //check for numeric
        if(isNaN(value)){
            message = validation.NotANumber
        }

        //check for range
        else if(this.state.valMin.length && this.state.valMax.length && (Number(value) < Number(this.state.valMin) || Number(value) > Number(this.state.valMax))){
            console.log("out of range")
            message = validation.OutOfRange.replace('<low>', this.state.valMin).replace('<high>', this.state.valMax)
        }

        //check for precision
        else if(Math.floor(value) != value){
            if(this.state.valPrecision == "0" || this.state.valPrecision == ""){
                message = validation.WholeNumbers
            } else {
                message = value.split('.')[1].length > this.state.valPrecision ? validation.InvalidPrecision : "" 
            }
        } 

        else {
            message = ''
        }

        this.setState({
            errorMessage: message,
            inputError: message.length ? true : false,
            answer: value
        })

        //then update state
        if (value && !message.length){
            this.setState({
                invalidAnswer: false,
                answer: value
            })
        } else {
            this.setState({
                invalidAnswer: true
            })
        }
        //console.log("value: " + value + " and message: " + message)
    }

    onBlur = (ev) => {
        //console.log(ev)
        setTimeout((ev) => {
            if(!this.state.invalidAnswer && !this.props.helpOpen){
                
                this.setState({saving: true})
                this.props.updateResponseValue(this.state.answer)
            }
        }, 100)
    }

    handleClick = (ev) => {
        if(!this.state.invalidAnswer && !this.state.saving){
            this.props.updateResponseValue(this.state.answer)
        }
    }

    render(){
        const {classes} = this.props
        let prompt = this.props.question.QuestionPrompt.length ? this.props.question.QuestionPrompt : "input"
        return(
            <div className={classes.root}>
                <TextField 
                    autoFocus={true}
                    borderRadius={0} 
                    className={classes.textfield} 
                    value={this.state.answer} 
                    variant="outlined" 
                    error={this.state.inputError}
                    helperText={this.state.errorMessage}
                    label={prompt} 
                    onChange={this.onChange}
                    onKeyPress={this.handleEnter}
                    onBlur={this.onBlur}/>
                <Button 
                    className={classes.button}
                    disabled={this.state.invalidAnswer} 
                    variant="contained" 
                    color="primary"
                    onClick={this.handleClick}
                    >
                        <NavigateNext /></Button> 
            </div>
        )
    }
}

export default InputAnswer